import {type RootState} from 'web-app/react/redux/root-state';
import createSelector from 'web-app/util/custom-create-selector';

import * as FiltersAndColumnsSelectors from './filters-and-columns/selectors';

const LIMIT = 25;

export const resultsQueryOrDefaultState = createSelector(
    FiltersAndColumnsSelectors.selectedColumnIds,
    FiltersAndColumnsSelectors.selectedFilters,
    (state: RootState) => state.lists.newList.filtersAndColumns.filtersAndColumnsKind,
    (state: RootState) => state.lists.newList.filtersAndColumns.institutionId,
    (state: RootState) => state.lists.newList.results.sortBy,
    (state: RootState) => state.lists.newList.results.sortOrder,
    (state: RootState) => state.lists.newList.results.offset,
    (columns, filters, kind, institutionId, sortBy, order, offset) => {
        return {
            filters,
            columns: columns.join(','),
            kind,
            institutionId,
            sortBy,
            order,
            limit: LIMIT,
            offset,
        };
    },
);

export const composeUrlQueryParams = createSelector(resultsQueryOrDefaultState, resultsQuery => {
    const {columns, filters, sortBy, order, kind} = resultsQuery;
    return {
        columns,
        ...filters,
        kind,
        sortBy,
        order,
    };
});
